import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScissors = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: 1.5,
		d: "M18.25 15.25 3.5 7.478M18.25 4.75 3.5 12.522M7.75 4.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm0 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
	})]
});
const ForwardRef = forwardRef(SvgScissors);
export { ForwardRef as ReactComponent };
